import React, { FC } from 'react';
import { toLocalID } from 'src/shared/helpers';
import type { StackedEditor, SidePanelProduct, ToolDefinition } from '../common/types';
import { PrintingMethodEditor } from '../editors/printingMethodEditor';
import { PricingRuleEditor } from '../editors/pricingRuleEditor';
import { GenericRuleEditor } from '../editors/genericRuleEditor';

export interface StackedEditorPanelProps {
    stackedEditor: StackedEditor | null;
    product: SidePanelProduct;
    toolDefinitions: ToolDefinition[];
    onCloseStacked: () => void;
    onGoToFullTool: (route: string, id?: string) => void;
    onNavigate: (url: string, state?: any) => void;
}

export const StackedEditorPanel: FC<StackedEditorPanelProps> = ({ stackedEditor, product, toolDefinitions, onCloseStacked, onGoToFullTool, onNavigate }) => (
    <>
        {stackedEditor && stackedEditor.type === 'printing-methods' && stackedEditor.id && (
            <PrintingMethodEditor
                productId={product.id}
                printTypeId={stackedEditor.id}
                onBack={onCloseStacked}
                onGoToFullTool={() => onGoToFullTool('/printing-method', stackedEditor.id)}
            />
        )}
        {stackedEditor && stackedEditor.type === 'pricing' && stackedEditor.id && (
            <PricingRuleEditor
                pricingId={stackedEditor.id}
                productId={product.id}
                onBack={onCloseStacked}
                onGoToFullTool={() => onGoToFullTool('/pricing-rule?pricing_id=' + toLocalID(stackedEditor.id))}
            />
        )}
        {stackedEditor &&
            (stackedEditor.type === 'printing-methods' || stackedEditor.type === 'pricing' ? !stackedEditor.id : stackedEditor.type !== 'pricing') && (
                <GenericRuleEditor
                    toolKey={stackedEditor.type}
                    itemId={stackedEditor.id}
                    productId={product.id}
                    productModelId={product.modelID}
                    onBack={onCloseStacked}
                    onGoToFullTool={() => {
                        const tool = toolDefinitions.find((t) => t.key === stackedEditor.type);
                        if (tool?.buildSetupRoute) {
                            onNavigate(tool.buildSetupRoute(product.modelID.toString()));
                        } else {
                            let itemId = stackedEditor.id;
                            try {
                                const decoded = atob(itemId);
                                if (decoded.includes(':')) itemId = decoded.split(':')[1];
                            } catch {
                                // not base64, use as-is
                            }
                            onGoToFullTool(tool?.detailRoute || tool?.route || '', itemId);
                        }
                    }}
                />
            )}
    </>
);
